import { axiosDS } from '@pp/axios'
import { urls } from 'Src/constants/Urls'
import { Auth } from 'Pages/auth'

async function updateProfile(
	id: number | string,
	data: Partial<Omit<Auth, 'avatar'>> & { avatar?: string }
) {
	const res = await axiosDS().patch<Auth>(`${urls.common.catalogs.user}/${id}`, { data })
	return res.data
}

async function updatePassword(
	id: number | string,
	data: {
		old_password: string
		password: string
		confirm_password: string
	}
) {
	const res = await axiosDS().patch<Auth>(
		urls.auth.updateAuthorizationData.replace(':id', String(id)),
		{
			data,
		}
	)
	return res.data
}

async function updateLogin(
	id: number | string,
	data: {
		old_password: string
		username: string
	}
) {
	const res = await axiosDS().patch<Auth>(
		urls.auth.updateAuthorizationData.replace(':id', String(id)),
		{
			data,
		}
	)
	return res.data
}

export const profileApi = {
	updateProfile,
	updatePassword,
	updateLogin,
}
